module.exports = __webpack_public_path__ + "static/media/bafu.f2da78d3.png";